<template>
<div class="btn-group" ref="dropdownFilter">
  <div @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name !== undefined">
    <span class="selected-name">
        {{ selectedOption.name }}
      </span>
    <svgicon name="arrow-down" class="dropdown-icon" width="12" height="12" :original="true" />
  </div>
  <ul class="dropdown-menu" v-if="showMenu">
    <li v-for="option in options" v-bind:key="option.id">
      <a href="javascript:void(0)" @click="updateOption(option)">
        {{ option.name }}
        </a>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  data() {
    return {
      selectedOption: {
        name: null,
      },
      showMenu: false,
      placeholderText: 'Please select an item',
    };
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
  },
  mounted() {
    this.selectedOption = this.selected;
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit('updateOption', this.selectedOption);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    documentClick(event) {
      const el = this.$refs.dropdownFilter;
      const target = event.target;
      if ((el !== target) && !el.contains(target)) {
        this.showMenu = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-group {
    min-width: 50px;
    position: relative;
    margin: 10px 0;
    display: inline-block;
    vertical-align: middle;
    .selected-name {
        display: inline-block;
        // width: 200px;
    }
}
.dropdown-toggle {
    min-width: 50px;
    cursor: pointer;
    padding: 0 0 0 10px;
    width: 170px;
    .dropdown-icon {
        float: right;
        top: 3px;
        position: relative;
    }
}
.dropdown-menu {
    width: 209px;
    position: absolute;
    z-index: 5;
    top: 15px;
    left: -11px;
    min-width: 50px;
    padding-left: 0;
    margin-top: 18px;
    list-style: none;
    font-size: 1rem;
    text-align: left;
    background-color: #fff;
    border: 1px solid #CBD4D8;
}
.dropdown-menu > li > a {
    padding: 10px 20px;
    display: block;
    clear: both;
    font-weight: normal;
    color: #646464;
    white-space: nowrap;
    text-decoration: none;
}
.dropdown-menu > li {
    font-size: 1.4rem;
    overflow: hidden;
    width: 100%;
    position: relative;
    margin: 0;
}
.tempsublevel{
  .btn-group{
    border-left:1px solid #DEE5E6;
    margin: -10px 0;
    height: 40px;
    padding: 10px 0;
    .selected-name{
      color: #4f5050;
      font-size: 1.4rem !important;
    }
    .dropdown-menu{
      top: 42px !important;
      left: -4px;
      li{
            margin: 0 0 0 0px !important;
        a{
            padding: 5px 10px;
        }
      }
    }
  }
}
</style>
